import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.81223 24V21.4784C9.81223 21.4041 9.78603 21.3322 9.73824 21.2754L3.32343 13.6463C3.30784 13.6277 3.2944 13.6076 3.28374 13.5858C2.64202 12.2771 2.9816 10.3591 5.41889 11.4526C5.45228 11.4675 5.48266 11.4879 5.50871 11.5136C5.82317 11.8239 7.98783 13.9599 8.14246 14.1127C8.30269 14.2711 8.15503 3.17297 8.1432 2.30209C8.14266 2.26234 8.14949 2.22873 8.16471 2.19201C8.68937 0.926587 10.4522 0.313366 11.4467 2.18C11.47 2.22371 11.4821 2.27355 11.4821 2.32308C11.4821 3.69289 11.4821 5.45159 11.4821 7.19167M11.4821 11.1466C11.4821 9.98225 11.4821 8.593 11.4821 7.19167M11.4821 7.19167C11.4821 7.19167 12.9849 5.04943 14.4877 7.19167M14.4877 7.19167C14.4877 8.73615 14.4877 11.1466 14.4877 11.1466M14.4877 7.19167C15.3089 5.73307 17.2606 6.18715 17.6425 7.1431C17.6552 7.17497 17.6604 7.20917 17.6604 7.24349V8.18039M17.6604 11.1466V8.18039M17.6604 8.18039C17.6604 8.18039 19.2791 6.2634 20.9228 8.0918C20.9726 8.1472 21 8.22126 21 8.29575V17.6885C21 17.7213 20.9949 17.754 20.9848 17.7853L19.8463 21.3162C19.8363 21.3475 19.8311 21.3801 19.8311 21.413V24",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgUse;
